import { createContext } from "react";

import { User } from "@meditect/medibase-api-client";

export interface UserContextValue {
  user: User;
}

export const UserContext = createContext<UserContextValue | null>(null);
